import { createApiActions } from '../../../helpers/actions';
import { ControlDataset } from '../../../models';

export const fetchControlDataset = createApiActions<ControlDataset>()(
  'controlDataset/fetch',
  'controlDataset/fetchSuccess',
  'controlDataset/fetchError',
  (siteId: number, date: Date) => ({ siteId, date })
);
